import React, { useState } from 'react';
import styled from 'styled-components';
import { formatCurrency, generateId } from '../utility/functions';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import useMetronome from '../utility/useMetronome';
import Button from '../forms/Button';
import Loading from '../Loading';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    width: 100%;
`;
const StatWrapper = styled.div`
    margin: 0 1em;
`;
const Row = styled.div`
    display: flex;
    align-items: center;
    padding: 0.2em 0;
`;
const TitleCell = styled.div`
    min-width: 50%;
    padding-left: 0.5em;
`;
const DataCell = styled.div`
    width: 30%;
`;
const TitleRow = styled(Row)`
    font-size: 1.2em;
    font-weight: bold;
    color: ${({ theme }) => theme.text};
`;
const DataRow = styled(Row)`
    border-top: 1px solid ${({ theme }) => theme.gray}45;
    color: ${({ theme }) => theme.gray};
`;
const BreakdownRow = styled(DataRow)`
    padding-left: 1rem;
    font-weight: 300;
`;
const TotalsRow = styled(Row)`
    font-weight: bolder;
    border-radius: 5em;
    padding: 0.2em 0;
    color: ${({ theme }) => theme.gray};
    background: ${({ theme }) => theme.gray}30;
`;

const Daily = ({ ...props }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.daily)
                .then(res => {
                    setData(res)
                    setLoading(false)
                })
                .catch(ex => console.error(ex))
        }
    }, 60000)

    const formatDataType = (type, data) => {
        switch (type) {
            case 'currency':
                return formatCurrency(data)
            default:
                return data
        }
    }

    return (
        <Wrapper>
            {!fetchData && <Button onClick={() => setFetchData(5)}>Refresh Widget</Button>}
            {loading
                ? <Loading />
                : data.map((e, i) => (
                    <StatWrapper key={`statWrap-${i}`}>
                        <TitleRow>
                            <TitleCell>{e.label}</TitleCell>
                            {i === 0 && (
                                <>
                                    <DataCell>Daily</DataCell>
                                    <DataCell>Monthly</DataCell>
                                </>
                            )}
                        </TitleRow>
                        {
                            e.data
                                .sort((a, b) => b.monthly - a.monthly)
                                .map((f, j) => (
                                    <div key={`statRow-${j}`}>
                                        <DataRow>
                                            <TitleCell>{f.label}</TitleCell>
                                            <DataCell>{formatDataType(e.type, f.daily)}</DataCell>
                                            <DataCell>{formatDataType(e.type, f.monthly)}</DataCell>
                                        </DataRow>

                                        {
                                            f.breakdown &&
                                            f.breakdown
                                                .sort((a, b) => b.monthly - a.monthly)
                                                .map((g, k) => (
                                                    <BreakdownRow key={`statBreakdown-${k}`}>
                                                        <TitleCell>{g.label}</TitleCell>
                                                        <DataCell>{formatDataType(e.type, g.daily)}</DataCell>
                                                        <DataCell>{formatDataType(e.type, g.monthly)}</DataCell>
                                                    </BreakdownRow>
                                                ))
                                        }
                                    </div>
                                ))
                        }
                        {e.totals && (
                            <TotalsRow>
                                <TitleCell>{e.totals.label}</TitleCell>
                                <DataCell>{formatDataType(e.type, e.totals.daily)}</DataCell>
                                <DataCell>{formatDataType(e.type, e.totals.monthly)}</DataCell>
                            </TotalsRow>
                        )}
                    </StatWrapper>
                ))
            }
        </Wrapper>
    );
}

export default Daily;